/*eslint-disable*/ export const messages = JSON.parse("{\"snackbar.aria.close\":[\"Dismiss message\"]}");
//# sourceMappingURL=messages.mjs.map